import React, {useEffect, useState} from 'react';
import {CardProductCodeName} from "../../constants/Card";

type Props = {
  cardProductCode: string;
}

const CardInfo: React.FC<Props> = ({cardProductCode}) => {

  const [cardName, setCardName] = useState<string>(CardProductCodeName[Number(cardProductCode)]);

  useEffect(() => {
    setCardName(CardProductCodeName[Number(cardProductCode)]);
  }, [cardProductCode]);

  return (
    <div className="cardInfo">
      <img src={`/assets/images/content/gmoney-card_${cardProductCode}.png`} alt={cardName}/>
      <span>{cardName}</span>
    </div>
  );
};

export default CardInfo;
